<nz-tree-select style="width: 100%"
                #nzTreeSelect
                [(ngModel)]="value"
                [nzNodes]="tree"
                [nzDefaultExpandAll]="true"
                [nzPlaceHolder]="placeholder"
                [nzDisplayWith]="display"
                [nzMultiple]="multipleSelect"></nz-tree-select>